/**
 * 加盟商管理api
 */
export default {
  // 营业执照文字识别
  getBizLicenseInfo: '/sysOCR/getBizLicenseInfo',
  // 公司信息-新增
  insertCompanyClient: '/companyClient/insertCompanyClient',
  // 公司信息-详情
  companyInfo: '/companyClient/selectCompanyClientDetailById',
  // 公司信息-列表
  companyList: '/companyClient/selectCompanyClientList',
  // 公司信息-修改状态
  companyStatus: '/companyClient/updateCompanyClientStatus',
  // 加盟商联系电话验证(唯一)
  contactTel:'/companyClient/contactTel'
};
